import XdslLineIntentionPopin from "../../../../common/broadband/components/XdslLineIntentionPopin.vue";
import CartRecovery from "./components/CartRecovery.vue";
import NewInternetOfferTile from "./components/NewInternetOfferTile.vue";
import OffersTabs from "./components/OffersTabs.vue";
import DiscountedInternetOfferTile from "./components/DiscountedInternetOfferTile.vue";
import {alignDivHeights, alignDivsHeightsByLine} from "../../utils/AlignDivHeightsUtil";
import GenericButtonCta from "../../../../common/broadband/components/GenericButtonCta.vue";
import InternetPushAnimationTile from "./components/InternetPushAnimationTile.vue";

const listOfDivToAlign = [
    "tag-timer", "title-align", "debit",
    "claim-0", "claim-1", "claim-2", "claim-3",
    "claim-content-0", "claim-content-1", "claim-content-2", "claim-content-3",
    "claims-container",
    "internet-secondary", "cross-discount-banner",
    "price-align", "mobileprice-align", "offer-edito-content", "mobileprice-odrmention-align", "detail-link-align"
];
const listOfCollapsibleDivToAlign = [
    "media-body-description-0", "media-body-description-1",
    "media-body-description-2", "media-body-description-3", "media-body-description-4", "media-body-description-5"
];

const root = document.getElementById("internet-offers-main");
const dto = JSON.parse(root.dataset.dto)

window.app = new Vue({
    el: root,
    name: "InternetOffersMain",
    components: {
        XdslLineIntentionPopin,
        CartRecovery,
        DiscountedInternetOfferTile,
        NewInternetOfferTile,
        OffersTabs,
        GenericButtonCta,
        InternetPushAnimationTile
    },
    data() {
        return {
            dto: dto,
            displayedInternetOffersTiles: null,
            displayedInternetOffersAnimationsTiles: null,
            displayedInternetMobileAtHomeOffersTiles: null,
            displayedAlternativeOffersTiles: null,
            showTabs: dto.showTabs,
            showOfferTechnologyChange: dto.showOfferTechnologyChange,
            hashTagInternet: "internet",
            hashTagInternetSmartTv: "internet_smart_tv",
            showAttributes: false,
            showMobileClientOffers: false,
            offersType: dto.offersType,
            toggleAttributesBtnLabel: dto.showAttributesBtnLabel,
            toggleAttributesBtnTms: dto.showAttributesBtnTms,
            showAttributesBtnTms: dto.showAttributesBtnTms,
            hideAttributesBtnTms: dto.hideAttributesBtnTms,
            showAttributesBtnLabel: dto.showAttributesBtnLabel,
            hideAttributesBtnLabel: dto.hideAttributesBtnLabel,
            showDetailPage: dto.showOfferDetailPage,
            showDetailPageBtnLabel: dto.showOfferDetailPageBtnLabel,
        }
    },
    computed: {
        fiberOffersLink() {
            if (!this.dto) {
                return null;
            } else {
                return this.dto.fiberOffersLink;
            }
        },
        adslOffersLink() {
            if (!this.dto) {
                return null;
            } else {
                return this.dto.adslOffersLink;
            }
        },
        internetOffersTiles() {
            if (this.dto && this.dto.offers) {
                return this.dto.offers;
            } else {
                return [];
            }
        },
        internetBasicsOffersTiles() {
            if (this.dto && this.dto.basicOffers) {
                return this.dto.basicOffers;
            } else {
                return [];
            }
        },
        internetSmartTVOffersTiles() {
            if (this.dto && this.dto.smartTVOffers) {
                return this.dto.smartTVOffers;
            } else {
                return [];
            }
        },
        internetOffersTilesForMobileClients() {
            if (this.dto && this.dto.defaultOffersForMobileClient) {
                return this.dto.defaultOffersForMobileClient;
            } else {
                return [];
            }
        },
        selectedInternetOfferSeoId() {
            if ((this.internetOffersTiles) && ((this.internetOffersTiles.length > 0))) {
                return this.internetOffersTiles[0].seoId;
            } else {
                return undefined;
            }
        },
        internetOffersAnimationsTiles() {
            if (this.dto && this.dto.offersAnimationsTiles) {
                return this.dto.offersAnimationsTiles;
            } else {
                return [];
            }
        },
        internetBasicsOffersAnimationsTiles() {
            if (this.dto && this.dto.basicOffersAnimationsTiles) {
                return this.dto.basicOffersAnimationsTiles;
            } else {
                return [];
            }
        },
        internetSmartTVOffersAnimationsTiles() {
            if (this.dto && this.dto.smartTVOffersAnimationsTiles) {
                return this.dto.smartTVOffersAnimationsTiles;
            } else {
                return [];
            }
        },
        internetMobileAtHomeOffersTiles() {
            if (this.dto && this.dto.mobileAtHomeOffers) {
                return this.dto.mobileAtHomeOffers;
            } else {
                return [];
            }
        },
        alternativeOffersTiles() {
            if (this.dto && this.dto.alternativeOffers) {
                return this.dto.alternativeOffers;
            } else {
                return [];
            }
        }
    },
    mounted() {
        this.addEventListerOnMenuFibreAdsl();
        this.selectInternetOffersTilesList();
        this.alignDivs(listOfDivToAlign);
        this.addElementsForModalToggle();
        this.addEventListerOnLiveboxPopinMenu();
        window.addEventListener("resize", this.resizeDivToAlign)
        this.$refs.offersRef.classList.remove('not-mounted');
        window.addEventListener("hashchange", this.updateSelectedTabFromHash);
    },
    updated() {
        this.alignDivs(listOfDivToAlign);
        this.addElementsForModalToggle();
    },
    beforeDestroy: function () {
        window.removeEventListener("hashchange", this.updateSelectedTabFromHash);
    },
    methods: {
        readHash() {
            const hash = window.location.hash;
            return hash.startsWith("#") ? hash.substring(1) : hash
        },
        updateSelectedTabFromHash() {
            const hash = this.readHash();
            if (hash !== this.hashTag) {
                if (hash === "") {
                    this.hashTag = "";
                } else if ([this.hashTagInternet, this.hashTagInternetSmartTv].includes(hash)) {
                    this.hashTag = hash;
                }
            }
        },
        getElementByXpath(path) {
            return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
        },
        addElementsForModalToggle() {
            document.querySelectorAll(".offer-edito-content").forEach(
                function (edito) {
                    const {oeventCategory, oeventLabel} = edito.dataset;

                    edito.querySelectorAll("a").forEach(
                        function (link) {
                            link.classList.add("fw-bold");
                            const hrefAttr = link.getAttribute("href");
                            if (hrefAttr.startsWith("#")) {
                                link.target = "_self";
                                link.dataset.bsToggle = "modal";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = oeventLabel;
                                link.dataset.oeventAction = hrefAttr.substr(1);
                            } else {
                                link.target = "_blank";
                            }
                        }
                    );
                }
            );
        },
        addEventListerOnLiveboxPopinMenu() {
            document.querySelectorAll(".livebox-multi-tab1").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        document.getElementById('tab1').classList.remove('d-none');
                        document.getElementById('tab2').classList.add('d-none')
                    }, false)
                }
            );
            document.querySelectorAll(".livebox-multi-tab2").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        document.getElementById('tab2').classList.remove('d-none');
                        document.getElementById('tab1').classList.add('d-none');
                    }, false)
                }
            );
        },
        addEventListerOnMenuFibreAdsl() {
            document.querySelectorAll(".menu-fibre-adsl").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        window.location.href = element.href
                    }, false)
                }
            );
        },
        toggleAttributes() {
            this.showAttributes = !this.showAttributes;
            if (this.showAttributes) {
                this.toggleAttributesBtnLabel = this.hideAttributesBtnLabel
                this.toggleAttributesBtnTms = this.hideAttributesBtnTms
                setTimeout(() => {
                    this.resizeCollapsibleDivToAlign()
                }, 100);
                window.addEventListener("resize", this.resizeCollapsibleDivToAlign)
            } else {
                this.toggleAttributesBtnLabel = this.showAttributesBtnLabel
                this.toggleAttributesBtnTms = this.showAttributesBtnTms
                window.removeEventListener("resize", this.resizeCollapsibleDivToAlign)
            }
        },
        resetToggleAttributes() {
            this.showAttributes = false;
            this.toggleAttributesBtnLabel = this.showAttributesBtnLabel
            this.toggleAttributesBtnTms = this.showAttributesBtnTms
            window.removeEventListener("resize", this.resizeCollapsibleDivToAlign)
        },
        resizeDivToAlign() {
            this.alignDivs(listOfDivToAlign);
        },
        resizeCollapsibleDivToAlign() {
            this.alignDivs(listOfCollapsibleDivToAlign);
        },
        alignDivs(divsToAlign) {
            if (this.dto && this.dto.alignOnlySameLineDivsHeights) {
                alignDivsHeightsByLine(divsToAlign);
            } else {
                alignDivHeights(divsToAlign);
            }
        },
        selectInternetOffersTilesList() {
            if (this.showTabs) {
                if (this.readHash() === this.hashTagInternetSmartTv) {
                    this.toggleTab(this.hashTagInternetSmartTv);
                }
                else {
                    this.toggleTab(this.hashTagInternet);
                }
            }
            else {
                this.displayedInternetOffersTiles = this.internetOffersTiles;
                this.displayedInternetOffersAnimationsTiles = this.internetOffersAnimationsTiles;
                this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
            }
        },
        toggleTab(selectedTab) {
            if (selectedTab.tab === this.hashTagInternet) {
                this.displayedInternetOffersTiles = this.internetBasicsOffersTiles;
                this.displayedInternetOffersAnimationsTiles = this.internetBasicsOffersAnimationsTiles;
                this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
                this.displayedAlternativeOffersTiles = this.alternativeOffersTiles;
            }
            else if (selectedTab.tab === this.hashTagInternetSmartTv) {
                this.displayedInternetOffersTiles = this.internetSmartTVOffersTiles;
                this.displayedInternetOffersAnimationsTiles = this.internetSmartTVOffersAnimationsTiles;
                this.displayedInternetMobileAtHomeOffersTiles = [];
                this.displayedAlternativeOffersTiles = [];
            }
            else {
                this.displayedInternetOffersTiles = this.internetBasicsOffersTiles;
                this.displayedInternetOffersAnimationsTiles = this.internetBasicsOffersAnimationsTiles;
                this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
                this.displayedAlternativeOffersTiles = this.alternativeOffersTiles;
            }
        }
    }
});
